<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Role"
      @click.native.stop
    >
      <v-select
        v-model="roleFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="role"
        placeholder="Select from list"
        multiple
        :options="roleOptions"
        :reduce="role => role._id"
      />
    </b-form-group>
    <b-form-group
      label="Related User"
      @click.native.stop
    >
      <v-select
        v-model="userFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="userOptions"
        :reduce="obj => obj._id"
      />
    </b-form-group>
    <b-form-group
      label="Activity Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Actions">
      <b-form-checkbox
        v-for="option in actionOptions"
        :key="option.key"
        v-model="actionFilterValue"
        :value="option.key"
        name="flavour-3a"
      >
        {{ option.name }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BFormCheckbox, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BFormCheckbox,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  props: {
    roleFilter: {
      type: [Array, null],
      default: null,
    },
    userFilter: {
      type: [Array, null],
      default: null,
    },
    actionFilter: {
      type: [Array, null],
      default: null,
    },
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
    actionOptions: {
      type: Array,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAtFilter,
      roleFilterValue: JSON.parse(JSON.stringify(this.roleFilter)) || [],
      userFilterValue: JSON.parse(JSON.stringify(this.userFilter)) || [],
      actionFilterValue: JSON.parse(JSON.stringify(this.actionFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    createdAtFilter: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
    userFilter: {
      immediate: true,
      handler(val) {
        this.userFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    actionFilter: {
      immediate: true,
      handler(val) {
        this.actionFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:roleFilter', this.roleFilterValue)
      this.$emit('update:userFilter', this.userFilterValue)
      this.$emit('update:actionFilter', this.actionFilterValue)
      this.$emit('update:createdAtFilter', this.createdAtFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.userFilterValue = []
      this.roleFilterValue = []
      this.actionFilterValue = []
      this.$emit('update:roleFilter', this.roleFilterValue)
      this.$emit('update:userFilter', this.userFilterValue)
      this.$emit('update:actionFilter', this.actionFilterValue)
      this.$emit('update:createdAtFilter', this.createdAtFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
